import { CustomField } from 'components/common/form/field/CustomField';
import { FormikField } from 'components/common/form/field/FormikField';
import { CollapsibleSection } from 'components/CollapsibleSection';
import { connect } from 'formik';
import i18next from 'i18n';
import _ from 'lodash';
import { FC, useCallback } from 'react';
import styles from './agencyForm.module.scss';

const AgencyCompanyAddonForm: FC<any> = (props) => {
  const { addonFeatures, companyName } = props.formik.values;
  const setFieldValue = props.formik.setFieldValue;
  const setValues = props.formik.setValues;

  const onRevenueReportChange = useCallback(
    (open) => {
      if (!open) {
        setValues((values) => ({
          ...values,
          addonFeatures: {
            ...values.addonFeatures,
            company: {
              ...values.addonFeatures.company,
              rebate: false,
              useAgencyProfitOnRebateReport: false,
              showOutComeOnRebateReport: false
            }
          }
        }));
      }
    },
    [setValues]
  );

  const onAgencySegmentAddonChange = useCallback(
    (open) => {
      if (open) {
        setFieldValue('addonProps.agencySegmentLimitationName', companyName);
        return;
      }
      setFieldValue('addonProps.agencySegmentLimitationName', '');
    },
    [companyName, setFieldValue]
  );

  return (
    <div className={styles.agencyFrom}>
      <fieldset>
        <legend>
          <span>{i18next.t('agency.addonGroup.company')}</span>
        </legend>
        <div className={styles.sectionsShadow}>
          <CollapsibleSection
            title={i18next.t('agency.addonGroup.company')}
            collapsible={false}
          >
            <div className={styles.fieldContent}>
              <FormikField.Switch
                label={i18next.t('agency.addonItem.company.productGroup')}
                name='addonFeatures.company.productGroup'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.company.agencySegment')}
                name='addonFeatures.company.agencySegment'
                onChange={onAgencySegmentAddonChange}
              />
              <CustomField label=''>
                <FormikField.Input
                  formGroupClassName={styles.addonPropsField}
                  label={i18next.t(
                    'agency.addonItem.company.agencySegmentLimitationName'
                  )}
                  name='addonProps.agencySegmentLimitationName'
                  fieldContentWidth={500}
                  disabled={!_.get(addonFeatures, 'company.agencySegment')}
                  postText={i18next.t('limitation.labels.agencySegment', {
                    name: ''
                  })}
                />
              </CustomField>
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.lookalikeAudienceCreation'
                )}
                name='addonFeatures.company.lookalikeAudienceCreation'
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.advAdminInfoRestriction'
                )}
                name='addonFeatures.company.advAdminInfoRestriction'
              />
            </div>
          </CollapsibleSection>
          <CollapsibleSection
            title={i18next.t('agency.addonGroup.reconciliationAndBudget')}
            collapsible={false}
          >
            <div className={styles.fieldContent}>
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.provideReportToWorkflow'
                )}
                name='addonFeatures.company.provideReportToWorkflow'
                onChange={onRevenueReportChange}
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.company.agencyProfit')}
                name='addonFeatures.company.agencyProfit'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.company.rebate')}
                name='addonFeatures.company.rebate'
                disabled={
                  !_.get(addonFeatures, 'company.provideReportToWorkflow')
                }
                hint={i18next.t('agency.addonItem.dependenceHint', {
                  addon: `${i18next.t('agency.addonGroup.reconciliationAndBudget')} > ${i18next.t('agency.addonItem.company.provideReportToWorkflow')}`
                })}
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.useAgencyProfitOnRebateReport'
                )}
                name='addonFeatures.company.useAgencyProfitOnRebateReport'
                disabled={
                  !_.get(addonFeatures, 'company.provideReportToWorkflow')
                }
                hint={i18next.t('agency.addonItem.dependenceHint', {
                  addon: `${i18next.t('agency.addonGroup.reconciliationAndBudget')} > ${i18next.t('agency.addonItem.company.provideReportToWorkflow')}`
                })}
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.showOutComeOnRebateReport'
                )}
                name='addonFeatures.company.showOutComeOnRebateReport'
                disabled={
                  !_.get(addonFeatures, 'company.provideReportToWorkflow')
                }
                hint={i18next.t('agency.addonItem.dependenceHint', {
                  addon: `${i18next.t('agency.addonGroup.reconciliationAndBudget')} > ${i18next.t('agency.addonItem.company.provideReportToWorkflow')}`
                })}
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.singleOrderBudgetConstraint'
                )}
                name='addonFeatures.company.singleOrderBudgetConstraint'
              />
              <CustomField label=''>
                <FormikField.Input
                  formGroupClassName={styles.addonPropsField}
                  label={i18next.t(
                    'agency.addonItem.company.orderBudgetMaximum'
                  )}
                  name='addonProps.orderBudgetMaximum'
                  fieldContentWidth='auto'
                  disabled={
                    !_.get(addonFeatures, 'company.singleOrderBudgetConstraint')
                  }
                />
              </CustomField>
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.allowOrderSettlement'
                )}
                name='addonFeatures.company.allowOrderSettlement'
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.allowOrderAutoSettlement'
                )}
                name='addonFeatures.company.allowOrderAutoSettlement'
                disabled={!_.get(addonFeatures, 'company.allowOrderSettlement')}
                hint={i18next.t('agency.addonItem.dependenceHint', {
                  addon: `${i18next.t('agency.addonGroup.reconciliationAndBudget')} > ${i18next.t('agency.addonItem.company.allowOrderSettlement')}`
                })}
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.modifyOrderBudgetAfterSettlement'
                )}
                name='addonFeatures.company.modifyOrderBudgetAfterSettlement'
                disabled={!_.get(addonFeatures, 'company.allowOrderSettlement')}
                hint={i18next.t('agency.addonItem.dependenceHint', {
                  addon: `${i18next.t('agency.addonGroup.reconciliationAndBudget')} > ${i18next.t('agency.addonItem.company.allowOrderSettlement')}`
                })}
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.company.storedValue')}
                name='addonFeatures.company.storedValue'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.company.fixedExchangeRate')}
                name='addonFeatures.company.fixedExchangeRate'
              />
              <CustomField label=''>
                <FormikField.Input
                  formGroupClassName={styles.addonPropsField}
                  label={i18next.t('agency.addonItem.company.ExchangeRate')}
                  name='addonProps.fixedExchangeRate'
                  fieldContentWidth='auto'
                  disabled={!_.get(addonFeatures, 'company.fixedExchangeRate')}
                />
              </CustomField>
            </div>
          </CollapsibleSection>
          <CollapsibleSection
            title={i18next.t('agency.addonGroup.creativeReview')}
            collapsible={false}
          >
            <div className={styles.fieldContent}>
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.directlyApproveCreative'
                )}
                name='addonFeatures.company.directlyApproveCreative'
              />
            </div>
          </CollapsibleSection>
          <CollapsibleSection
            title={i18next.t('agency.addonGroup.adsOrder')}
            collapsible={false}
          >
            <div className={styles.fieldContent}>
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.order.showOrderExternalType'
                )}
                name='addonFeatures.order.showOrderExternalType'
              />
            </div>
          </CollapsibleSection>
          <CollapsibleSection
            title={i18next.t('agency.addonGroup.conversiontracking')}
            collapsible={false}
          >
            <div className={styles.fieldContent}>
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.conversiontracking.TrackingList'
                )}
                name='addonFeatures.conversiontracking.TrackingList'
              />
            </div>
          </CollapsibleSection>
          <CollapsibleSection
            title={i18next.t('agency.addonGroup.report')}
            collapsible={false}
          >
            <div className={styles.fieldContent}>
              <FormikField.Switch
                label={i18next.t('agency.addonItem.report.viewableCtr')}
                name='addonFeatures.report.viewableCtr'
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.company.advertiserViewSpentInReport'
                )}
                name='addonFeatures.company.advertiserViewSpentInReport'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.report.closingReport')}
                name='addonFeatures.report.closingReport'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.report.restrictFinalReport')}
                name='addonFeatures.report.restrictFinalReport'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.report.orderCustom')}
                name='addonFeatures.report.orderCustom'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.report.campaignDashboard')}
                name='addonFeatures.report.campaignDashboard'
              />
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.report.cantDownloadOutdoorFinalReport'
                )}
                name='addonFeatures.report.cantDownloadOutdoorFinalReport'
              />
              <FormikField.Switch
                label={i18next.t('agency.addonItem.report.deliveryBriefReport')}
                name='addonFeatures.report.deliveryBriefReport'
              />
            </div>
          </CollapsibleSection>
          <CollapsibleSection
            title={i18next.t('agency.addonGroup.monitor')}
            collapsible={false}
          >
            <div className={styles.fieldContent}>
              <FormikField.Switch
                label={i18next.t(
                  'agency.addonItem.monitor.campaignBehindProgress'
                )}
                name='addonFeatures.monitor.campaignBehindProgress'
              />
            </div>
          </CollapsibleSection>
        </div>
      </fieldset>
    </div>
  );
};

export default connect(AgencyCompanyAddonForm);
